module.exports = __webpack_public_path__ + "media/images/gifts/cook/sug_cozinhar_1-3cc75a615c3dee62a9a43fcb7627164a.jpg";